import { useEffect } from "react";
import { useTheme } from "next-themes";
import { theme as themeConfig } from "@/config/portfolio.config";

/**
 * Injects CSS custom properties from portfolio.config.ts
 * so that changing colors in the config rebrands the entire site.
 */
const ThemeInjector = () => {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const mode = resolvedTheme === "dark" ? "dark" : "light";
    const colors = themeConfig.colors[mode];

    const mappings: Record<string, string> = {
      "--primary": colors.primary,
      "--accent": colors.accent,
      "--background": colors.background,
      "--foreground": colors.foreground,
      "--card": colors.card,
      "--card-foreground": colors.foreground,
      "--popover": colors.card,
      "--popover-foreground": colors.foreground,
      "--muted": colors.muted,
      "--muted-foreground": colors.mutedForeground,
      "--border": colors.border,
      "--input": colors.border,
      "--ring": colors.primary,
      "--primary-foreground": mode === "dark" ? colors.background : "0 0% 100%",
      "--accent-foreground": mode === "dark" ? colors.background : "0 0% 100%",
      "--secondary": colors.muted,
      "--secondary-foreground": colors.foreground,
      "--glow": colors.primary,
      "--glow-secondary": colors.accent,
      "--gradient-start": colors.primary,
      "--gradient-end": colors.accent,
    };

    Object.entries(mappings).forEach(([prop, value]) => {
      root.style.setProperty(prop, value);
    });
  }, [resolvedTheme]);

  return null;
};

export default ThemeInjector;
